<template>
    <div class="not-found">
        <div class="text">
            <h2>Oops... we can't<br>
                find the page<br>
                you're looking for</h2>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NotFound',
}
</script>


<style lang="scss">

    html body.page-not-found {        
        background: var(--dark-blue)
    }

    .not-found {
        height: 100vh;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        .text {
            text-align: center;

            h2 {
                font-size: 6vw;
                line-height: 1.15;
                color: white;
                position: relative;
                top: -5vw;
            }


        }
    }
</style>
